import { infusePrior, NAs } from "../configs";
import { findCharacter, getPartyData } from "../data/controllers";
import { findByIndex } from "../helpers";
import getBuffedStats from "./buffedStats";
import getDmg from "./damage";

export const charDataSelect = "code name nation vision weapon";

export default function calculateAll(
  char,
  charData,
  selfMCs,
  party,
  weapon,
  subWpMCs,
  arts,
  elmtMCs,
  customMCs,
  target,
  tracker
) {
  const finalInfusion = getFinalInfusion(
    char,
    selfMCs.BCs,
    charData.vision,
    party
  );
  const partyData = getPartyData(party);
  const [ATTRs, hitBnes, rxnBnes, artSBnes] = getBuffedStats(
    char,
    charData,
    selfMCs.BCs,
    weapon,
    subWpMCs.BCs,
    arts,
    elmtMCs,
    party,
    partyData,
    customMCs.BCs,
    finalInfusion,
    tracker
  );
  const dmg = getDmg(
    char,
    charData,
    selfMCs,
    party,
    partyData,
    arts.subDCs,
    ATTRs,
    hitBnes,
    rxnBnes,
    customMCs.DCs,
    finalInfusion,
    elmtMCs,
    target,
    tracker
  );
  return [finalInfusion, ATTRs, hitBnes, rxnBnes, artSBnes, dmg];
}

function getFinalInfusion(char, selfBCs, ownVision, party) {
  const selfInfusion = [];
  const charData = findCharacter(char, "weapon buffs");
  for (const ctrl of selfBCs) {
    const buff = findByIndex(charData.buffs, ctrl.index);
    if (buff && buff.canInfuse && ctrl.activated && buff.isGranted(char)) {
      const { infuseRange: range, canBeOverrided } = buff;
      selfInfusion.push({ range, canBeOverrided });
    }
  }
  const tmInfusion = [];
  for (const tm of party.filter((m) => m)) {
    const { buffs, vision } = findCharacter(tm);
    for (const ctrl of tm.BCs) {
      const buff = findByIndex(buffs, ctrl.index);
      if (
        buff &&
        buff.canInfuse &&
        ctrl.activated &&
        buff.canInfuse(charData)
      ) {
        tmInfusion.push({ elmt: vision, range: buff.infuseRange });
      }
    }
  }
  const result = {};
  for (const type of NAs) {
    result[type] = strongestInfusion(type, selfInfusion, ownVision, tmInfusion);
  }
  return result;
}
function strongestInfusion(type, selfInfusion, ownVision, tmInfusion) {
  const contenders = ["Physical"];
  for (const ifs of selfInfusion) {
    if (ifs.range.includes(type)) {
      if (!ifs.canBeOverrided) {
        return ownVision;
      } else if (!contenders.includes(ownVision)) {
        contenders.unshift(ownVision);
      }
    }
  }
  const pos = (elmt) => infusePrior.indexOf(elmt);
  for (const ifs of tmInfusion) {
    for (const index in contenders) {
      if (pos(ifs.elmt) < pos(contenders[index])) {
        // no need infusion.range yet
        contenders.splice(index, 0, ifs.elmt);
        break;
      }
    }
  }
  return contenders[0];
}
